import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery
} from "@mui/material";
import React, {useCallback, useState} from "react";

const useStyles = makeStyles(theme => ({
    content: {
        whiteSpace: 'pre-wrap'
    }
}))

function AgreePrivacyPolicyModal({handleClickAgree, handleClickDisagree, handleCloseModal, openModal, content, version, isLoading}) {
    const theme = useTheme();
    const classes = useStyles();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [disableAgreeBtn, setDisableAgreeBtn] = useState(true);
    const dialog = useCallback(node => {
        if (node !== null) {
            setDisableAgreeBtn(node.clientHeight < node.scrollHeight);
        }
    }, []);


    const handleScrollEvent = (event) => {
        const el = event.currentTarget; // safer than event.target
        const denom = Math.max(1, el.scrollHeight - el.clientHeight);
        const ratio = el.scrollTop / denom;
        if (ratio >= 0.9) setDisableAgreeBtn(false); // 90% threshold
    };

    return (
            <Dialog
                open={openModal}
                fullScreen={fullScreen}
                maxWidth="md"
                fullWidth
                scroll="paper"                 // <-- use paper
                onClose={handleCloseModal}
            >
                {isLoading ? <DialogTitle>Loading...</DialogTitle> :
                <>
                    <DialogTitle>Privacy Policy, {version}</DialogTitle>
                    <DialogContent
                        ref={dialog}
                        onScroll={handleScrollEvent}     // <-- now attach here
                    >
                        <DialogContentText className={classes.content}>
                            {content}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClickDisagree} color="secondary">
                            DISAGREE
                        </Button>
                            <Button disabled={disableAgreeBtn} onClick={handleClickAgree} color="primary">
                            AGREE
                        </Button>
                    </DialogActions>
                </>
            }
        </Dialog>
    )
}

export { AgreePrivacyPolicyModal };